module.exports = __webpack_public_path__ + "static/media/loading.63305967.63305967.gif";